<ng-content></ng-content>
<label class="radio-label" [attr.for]="_control?.id">{{label}}</label>